
$(function() {

    $('a.delete-card').click(function(event) {
        event.preventDefault();
        let deleteCardModal = $('#delete-card-modal');
        deleteCardModal.attr('data-url', $(this).attr('href'));
        console.log($(this).attr('href'));
        deleteCardModal.modal('show');
    });


    $('#delete-card-modal #submit-modal').click(function () {
        let url = $('#delete-card-modal').data('url');

        window.open(url, '_self');
        $(this).closest('#delete-card-modal').modal('hide');
    });
});